export default {
  // Hero Section
  'hero.title.invest': 'Investīcijas - Uzturēšanās',
  'hero.title.card': 'Saņemiet Eiropas Uzturēšanās Karti',
  'hero.description': 'Investējiet Asian Alley veikalā - Saņemiet Latvijas uzturēšanās karti 4-6 mēnešos visai ģimenei',
  'hero.cta.consult': 'Reģistrēties Bezmaksas Konsultācijai',
  'hero.cta.learnMore': 'Uzzināt Vairāk',
  'hero.stat1.title': '4-6 Mēneši',
  'hero.stat1.desc': 'Ātra dokumentu apstrādes laiks',
  'hero.stat2.title': 'Visa Ģimene',
  'hero.stat2.desc': 'Laulātie un bērni līdz 18 gadiem',
  'hero.stat3.title': 'Drošība',
  'hero.stat3.desc': 'Pārbaudīts biznesa modelis',

  // Benefits Section
  'benefits.title': 'Izcili Ieguvumi',
  'benefits.description': 'Latvijas uzturēšanās sniedz Jums un Jūsu ģimenei visaptverošas attīstības iespējas',
  'benefits.1.title': 'Eiropas Uzturēšanās Karte',
  'benefits.1.desc': 'Saņemiet Latvijas uzturēšanās karti, brīvi ceļojiet 26 Šengenas valstīs',
  'benefits.2.title': 'Kvalitatīva Izglītība',
  'benefits.2.desc': 'Bērni var piekļūt progresīvai Eiropas izglītības sistēmai ar bezmaksas mācību maksu uzturēšanās gadījumā.',
  'benefits.3.title': 'Moderna Veselības Aprūpe',
  'benefits.3.desc': 'Baudiet Eiropas veselības aprūpes sistēmu ar saprātīgām izmaksām un augstu pakalpojumu kvalitāti',
  'benefits.4.title': 'Drošība un Stabilitāte',
  'benefits.4.desc': 'Latvija ir ES un NATO dalībvalsts ar drošu, stabilu dzīves vidi',
  'benefits.5.title': 'Droša Uzturēšanās',
  'benefits.5.desc': 'Pārbaudīts biznesa modelis, garantējot ģimenes kartes drošību visus 5 uzturēšanās gadus',
  'benefits.6.title': 'Darba Iespējas',
  'benefits.6.desc': 'Piedalieties darbā tieši Asian Alley veikalos sistēmā',

  // Process Section
  'process.title': 'Īstenošanas Process',
  'process.description': '6 vienkārši soļi, lai pabeigtu Latvijas uzturēšanās dokumentus 4-6 mēnešos',
  'process.step1.title': 'Konsultācija un Novērtējums',
  'process.step1.desc': 'Mūsu konsultanti sniegs detalizētas konsultācijas par programmu un novērtēs jūsu dokumentus',
  'process.step2.title': 'Dokumentu Sagatavošana',
  'process.step2.desc': 'Atbalsts pilnīgu juridisko dokumentu un nepieciešamo materiālu sagatavošanā saskaņā ar prasībām',
  'process.step3.title': 'Investīciju Līguma Parakstīšana',
  'process.step3.desc': 'Parakstiet investīciju līgumu Asian Alley veikalā ar skaidriem, pārredzamiem noteikumiem',
  'process.step4.title': 'Dokumentu Iesniegšana',
  'process.step4.desc': 'Iesniedziet uzturēšanās kartes pieteikumu Latvijas imigrācijas iestādē',
  'process.step5.title': 'Intervija un Izskatīšana',
  'process.step5.desc': 'Atbalsts intervijas sagatavošanā un dokumentu izskatīšanas procesa uzraudzībā',
  'process.step6.title': 'Uzturēšanās Kartes Saņemšana',
  'process.step6.desc': 'Saņemiet Latvijas uzturēšanās karti visai ģimenei',
  'process.note': 'Apstrādes laiks:',
  'process.noteTime': '4-6 mēneši no pilnīgu dokumentu iesniegšanas',

  // Packages Section
  'packages.badge': 'Pārredzamas izmaksas',
  'packages.title': 'Uzturēšanās Izmaksas',
  'packages.description': 'Latvijas uzturēšanās izmaksu pārskats — pārredzams, skaidrs, bez papildu maksām',
  'packages.common.title': 'Kopējās Izmaksas',
  'packages.excluded.title': 'Nav Iekļauts',
  'packages.cost1.label': 'Investīcijas vērtība',
  'packages.cost1.amount': '50,000 EUR',
  'packages.cost2.label': 'Valdības Nodoklis',
  'packages.cost2.amount': '10,000 EUR',
  'packages.excluded1': 'Lidmašīnas biļetes',
  'packages.excluded2': 'Vīzas izmaksas',
  'packages.excluded3': 'Citas izmaksas, kas rodas procedūru laikā, bet nav iekļautas līgumā',
  'packages.note': 'Apņemšanās pārredzamām izmaksām — Nav papildu maksu ārpus līguma',

  // FAQ Section
  'faq.title': 'Bieži Uzdotie Jautājumi',
  'faq.description': 'Atbildes uz izplatītākajiem jautājumiem par Latvijas uzturēšanās programmu',
  'faq.q1': 'Kāpēc izvēlēties Latvijas uzturēšanos?',
  'faq.a1': 'Latvija ir Eiropas Savienības (ES) un Šengenas zonas dalībvalsts, kad jums ir Latvijas uzturēšanās karte, jūs saņemsiet: Brīvu pārvietošanos 29 Šengenas valstīs. Likumīgas dzīvošanas tiesības Eiropā. Iespēju bērniem mācīties ES ar zemām izmaksām. Iespēju paplašināt biznesu Eiropas tirgū. Zemas investīciju izmaksas salīdzinājumā ar citām ES uzturēšanās programmām.',
  'faq.q2': 'Vai 50,000 EUR investīcija tiks zaudēta?',
  'faq.a2': '50,000 EUR ir dalības maksa programmā, lai izpildītu nosacījumus Latvijas pagaidu uzturēšanās kartes saņemšanai saskaņā ar valdības noteikumiem. Šīs summas galvenais mērķis ir palīdzēt jums un jūsu ģimenei saņemt likumīgas uzturēšanās tiesības Eiropā. Pēc minimālā 5 gadu uzturēšanās perioda, atkarībā no darbības situācijas un programmas nosacījumiem tajā laikā, jūs varat saņemt atpakaļ aptuveni 10,000 – 15,000 EUR. Atlikušās izmaksas tiek uzskatītas par programmas dalības un uzturēšanās nosacījumu uzturēšanas izmaksām, līdzīgi kā citās Eiropas uzturēšanās programmās.',
  'faq.q3': 'Cik ilgā laikā es saņemšu uzturēšanās karti?',
  'faq.a3': 'Parasti apstrādes laiks: 6 – 12 mēneši no dokumentu un investīcijas pabeigšanas. Ar VIP paketi dokumenti tiek apstrādāti ātrāk.',
  'faq.q4': 'Vai man jādzīvo Latvijā?',
  'faq.a4': 'Nav obligāti dzīvot Latvijā pilnu laiku. Jūs joprojām varat: Dzīvot Vjetnamā, Ceļot uz Eiropu, kad nepieciešams, Uzturēt likumīgu uzturēšanās karti. Programma ir ļoti piemērota: Uzņēmumu īpašniekiem; Investoriem; Cilvēkiem, kas vēlas "Eiropas uzturēšanās tiesības rezervē".',
  'faq.q5': 'Vai mana ģimene var doties līdzi?',
  'faq.a5': 'Jā. Programma ļauj iekļaut: Laulāto, Apgādājamos bērnus. Visa ģimene saņem Latvijas uzturēšanās karti vienlaicīgi.',
  'faq.q6': 'Ko es saņemšu pēc Latvijas uzturēšanās?',
  'faq.a6': 'Jūs saņemsiet: Latvijas uzturēšanās karti, Tiesības dzīvot Eiropā, Brīvu pārvietošanos Šengenā, Iespēju bērniem mācīties ES, Pamatu starptautiskā biznesa paplašināšanai. Tas ir svarīgs solis, lai nākotnē kļūtu par Eiropas pilsoni.',
  'faq.q7': 'Vai uzņēmums atbalsta darba meklēšanu, kad es ierados Latvijā?',
  'faq.a7': 'Pēc ierašanās Latvijā, atkarībā no spējām, uzņēmums atbalstīs darba iepazīstināšanu uzņēmumos/rūpnīcās vai tiešu darbu Asian Alley veikalā.',
  'faq.q8': 'Kāpēc darīt to tagad?',
  'faq.a8': 'ES uzturēšanās programmas parasti: Palielina izmaksas laika gaitā; Maina politiku; Pastiprina nosacījumus. Pašlaik Latvija joprojām ir programma: Zemas izmaksas; Vienkārši nosacījumi; Augsts panākumu līmenis. Agrīna rīcība ietaupīs izmaksas un nodrošinās iespējas.',
  'faq.q9': 'Kāpēc programma izvēlas investēt Asian Alley?',
  'faq.a9': 'Asian Alley ir Āzijas veikals, ko vada vjetnamieši Latvijā, darbojies daudzus gadus ar stabilu biznesa pamatu. 1. Uzņēmuma īpašnieks ir vjetnamietis – viegli atbalstīt, Saprot vjetnamiešu klientu vajadzības un psiholoģiju, Viegli sazināties, atbalstīt un rīkoties, kad nepieciešams. 2. Uzņēmums darbojas reāli un stabili. Veikals darbojas reāli, nav uzņēmums, kas atvērts tikai dokumentu veidošanai. Ir stabila klientu bāze Latvijā. Ir skaidra darbības vēsture. Tas garantē, ka programma ir likumīga un droša. 3. Garantē Latvijas uzturēšanās kartes nosacījumus, Investīcijas galvenais mērķis ir: Izpildīt uzturēšanās programmas nosacījumus, Palīdzēt klientiem saņemt likumīgu Latvijas pagaidu uzturēšanās karti, Uzturēt karti ilgu laiku. Asian Alley pilnībā izpilda šos juridiskos nosacījumus.',

  // Stats Section
  'stats.title': 'Iespaidīgie Skaitļi',
  'stats.description': 'Mūsu lepnie sasniegumi Latvijas uzturēšanās jomā',
  'stats.1.number': '500+',
  'stats.1.label': 'Uzticīgi Klienti',
  'stats.2.number': '98%',
  'stats.2.label': 'Panākumu Līmenis',
  'stats.3.number': '4-6',
  'stats.3.label': 'Mēneši Dokumentu Apstrādei',
  'stats.4.number': '5+',
  'stats.4.label': 'Gadu Pieredze',
  'stats.asian.title': 'ASIAN ALLEY ĀZIJAS VEIKALS LATVIJĀ',
  'stats.asian.location': '2 filiāles Rīgas centrā, Latvijā',
  'stats.asian.revenue': 'Gada apgrozījums',

  // CTA Section
  'cta.title': 'Sāciet Savu Uzturēšanās Ceļojumu',
  'cta.description': 'Nepalaidiet garām zelta iespēju iegūt Eiropas uzturēšanās karti. Mūsu ekspertu komanda ir gatava sniegt bezmaksas konsultācijas un pavadīt jūs visā uzturēšanās ceļojumā.',
  'cta.button.consult': 'Reģistrēties Bezmaksas Konsultācijai',
  'cta.button.call': 'Zvanīt Tagad',

  // Detail Hero Section
  'detail.hero.badge': 'Eiropas vārti',
  'detail.hero.title': 'Latvijas Uzturēšanās',
  'detail.hero.titleSub': '- Eiropas Uzturēšanās Iespēja',
  'detail.hero.description': 'Latvija - Zelta vārti, lai iegūtu Eiropas uzturēšanās karti ar saprātīgām izmaksām un ātru procesu. Latvijas uzturēšanās investīcija tikai no 50,000 EUR.',

  // Why Latvia Section
  'detail.why.title': 'Kāpēc Izvēlēties',
  'detail.why.titleBold': 'Latvijas Uzturēšanos',
  'detail.why.p1': 'Latvija ir Eiropas Savienības un Šengenas zonas dalībvalsts, atrodas stratēģiskā vietā Ziemeļaustrumeiropā. Ar elastīgu uzturēšanās politiku caur investīcijām, Latvija kļūst par pievilcīgu galamērķi daudzām Vjetnamas ģimenēm, kas vēlas uzturēties Eiropā.',
  'detail.why.p2': 'Latvijas investīciju uzturēšanās programma ļauj jums un jūsu ģimenei saņemt pagaidu uzturēšanās karti tikai 4-6 mēnešos, investējot vietējā uzņēmumā, piemēram, Asian Alley veikalā. Latvijas uzturēšanās izmaksas ir saprātīgas, process ir pārredzams.',
  'detail.why.stat1': 'Šengenas Valsts',
  'detail.why.stat2': 'Iedzīvotāji',

  // Requirements Section
  'detail.requirements.title': 'Nosacījumi',
  'detail.requirements.titleBold': 'Latvijas Investīciju Uzturēšanās',
  'detail.requirements.description': 'Vienkārši un viegli izpildāmi nosacījumi lielākajai daļai Vjetnamas ģimeņu, kas vēlas uzturēties Latvijā',
  'detail.requirements.1.title': 'Vecums',
  'detail.requirements.1.desc': 'No 18 gadiem, nav maksimālā vecuma ierobežojuma',
  'detail.requirements.2.title': 'Tīra Reputācija',
  'detail.requirements.2.desc': 'Nav kriminālās pagātnes, tīra juridiskā vēsture',
  'detail.requirements.3.title': 'Finansiālā Spēja',
  'detail.requirements.3.desc': 'Spēja investēt no €50,000 vai vairāk',
  'detail.requirements.4.title': 'Pilnīgi Dokumenti',
  'detail.requirements.4.desc': 'Sagatavot pilnīgus dokumentus saskaņā ar imigrācijas iestādes prasībām',

  // Asian Alley Invest Section
  'detail.asian.title': 'Investīcija Asian Alley',
  'detail.asian.titleSub': '- Latvijas Uzturēšanās Ceļš',
  'detail.asian.description': 'Asian Alley ir vadošā Āzijas veikalu ķēde Latvijā ar 2 filiālēm Rīgas centrā. Veikals specializējas kvalitatīvu Āzijas pārtikas un preču piegādē, apkalpojot arvien lielāku Āzijas kopienu Latvijā.',
  'detail.asian.location.label': 'Atrašanās vieta:',
  'detail.asian.location.value': '2 filiāles Rīgas centrā, Latvijā',
  'detail.asian.revenue.label': 'Apgrozījums:',
  'detail.asian.revenue.value': 'Vairāk nekā €500,000/gadā un aug',
  'detail.asian.customers.label': 'Klienti:',
  'detail.asian.customers.value': 'Apkalpo tūkstošiem klientu katru mēnesi',
  'detail.asian.button': 'Uzzināt Detaļas',

  // Benefits Detail Section
  'detail.benefits.title': 'Tiesības',
  'detail.benefits.titleSub': 'Latvijas Pagaidu Uzturēšanās Karte',
  'detail.benefits.description': 'Praktiski ieguvumi, iegūstot Latvijas pagaidu uzturēšanās karti un uzturēšanos Eiropā',
  'detail.benefits.1': 'Brīva pārvietošanās 26 Šengenas valstīs',
  'detail.benefits.2': 'Tiesības uzturēties un strādāt Latvijā',
  'detail.benefits.3': 'Bērni var mācīties bez maksas',
  'detail.benefits.4': 'Baudīt Eiropas veselības aprūpes sistēmu',
  'detail.benefits.5': 'Pēc 10 gadiem var pieteikties Latvijas pilsonībai',
  'detail.benefits.6': 'Droša, civilizēta dzīves vide',
  'detail.benefits.7': 'Saprātīgas dzīves izmaksas',
  'detail.benefits.8': 'Paplašinās vjetnamiešu kopiena',
  'detail.benefits.button': 'Reģistrēties Bezmaksas Konsultācijai',

  // Investment Usage Section
  'detail.usage.title': 'Ko Mēs Darām ar Jūsu',
  'detail.usage.titleBold': 'Latvijas Uzturēšanās Investīciju',
  'detail.usage.titleEnd': '?',
  'detail.usage.description': 'Jūsu investīcija tiek izmantota pārredzami un efektīvi Asian Alley sistēmas attīstībai',
  'detail.usage.1.title': 'Veikalu Paplašināšana',
  'detail.usage.1.desc': 'Investīcija Asian Alley veikalu ķēdes paplašināšanā Latvijā un Baltijas reģionā, palielinot filiāļu skaitu un biznesa apjomu',
  'detail.usage.2.title': 'Produktu Paplašināšana',
  'detail.usage.2.desc': 'Dažādot kvalitatīvu Āzijas produktu klāstu, apmierinot kopienas pieaugošās vajadzības',
  'detail.usage.3.title': 'Loģistikas Uzlabošana',
  'detail.usage.3.desc': 'Investīcija modernā noliktavu, transporta un piegādes ķēdes pārvaldības sistēmā, nodrošinot, ka preces vienmēr ir svaigi',
  'detail.usage.4.title': 'Personāla Attīstība',
  'detail.usage.4.desc': 'Pieņemt darbā un apmācīt profesionālu personālu, radot darba iespējas vjetnamiešu kopienai Latvijā',
  'detail.usage.commitment.title': 'Pārredzamības Apņemšanās',
  'detail.usage.commitment.desc': 'Visas investīcijas tiek izmantotas Asian Alley reālās biznesa attīstības mērķiem. Mēs apņemamies būt pārredzami par darbības situāciju un kapitāla izmantošanu, garantējot Latvijas uzturēšanās investoru tiesības.',

  // Blog Preview Section
  'detail.blog.title': 'Ziņas un Ceļvedis',
  'detail.blog.titleBold': 'Latvijas Uzturēšanās',
  'detail.blog.description': 'Jaunākā informācija par politiku un uzturēšanās pieredzi',
  'detail.blog.viewAll': 'Skatīt visu',
  'detail.blog.viewAllMobile': 'Skatīt visus rakstus',

  // Page Meta
  'meta.latvia.title': 'Latvijas Uzturēšanās 2025 - Nosacījumi, Process un Investīciju Izmaksas | The Daeg International',
  'meta.latvia.description': 'Detalizēts ceļvedis par Latvijas uzturēšanos 2025: Investīciju nosacījumi no 50,000 EUR, 4-6 mēnešu process, Šengenas pagaidu uzturēšanās kartes tiesības. Investīcija Asian Alley - vadošajā Āzijas veikalu ķēdē Rīgā, Latvijā. Bezmaksas konsultācija vjetnamiešiem.',
  'meta.latvia.keywords': 'latvijas uzturēšanās 2025, latvijas uzturēšanās nosacījumi, latvijas uzturēšanās izmaksas, latvijas uzturēšanās process, asian alley investīcija, šengenas pagaidu uzturēšanās karte, rīgas uzturēšanās, latvijas uzturēšanās tiesības, eiropas imigrācija',
  'meta.detail.title': 'Latvijas Uzturēšanās Detaļas - Nosacījumi, Tiesības un Investīcija | The Daeg International',
  'meta.detail.description': 'Detalizēta informācija par Latvijas uzturēšanos: Kāpēc izvēlēties Latviju, investīciju nosacījumi no 50,000 EUR, Šengenas pagaidu uzturēšanās kartes tiesības, investīcija Asian Alley. Bezmaksas konsultācija vjetnamiešiem.',
  'meta.detail.keywords': 'latvijas uzturēšanās detaļas, latvijas uzturēšanās nosacījumi, pagaidu uzturēšanās kartes tiesības, asian alley investīcija, eiropas uzturēšanās, šengenas karte',
};